import { Component, forwardRef, Inject, Input } from '@angular/core';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { CustomersService } from './customers.service';
import { InvoiceModel }     from '../invoices/models/invoice';
import { Table }            from '../table/types/table';

@Component({
  selector   : 'wor-customer-branch-history',
  template: require('./customer.branch-history.component.html')
})
export class CustomerBranchHistoryComponent {
  @Input() invoices: Array<InvoiceModel> = [];

  tableSettings: Table = {
    columns: [
      {
        field : 'store_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STORE_NAME')
        }
      },
      {
        field : 'invoice_number',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_type',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
        },
        pipe: 'invoiceType'
      },
      {
        field : 'invoice_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'cash_or_account',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType'
      },
      {
        field : 'total',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        field : 'balance_due',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => CustomersService))
    private customersService: CustomersService,
    private translateService: TranslateService
  ) {}

  openReport ( invoice : InvoiceModel ) : void {
    this.customersService.viewReport(invoice);
  }
}
